// extracted by mini-css-extract-plugin
module.exports = {"header":"LocationOverviewTab_header__s-Wva","headerWrapper":"LocationOverviewTab_headerWrapper__2RwdO"};